<h5 class="flex justify-center md:justify-end items-center font-normal">
  Your cart will expire in...
  <span class="ml-1 font-bold">{{ getTimer }}</span>
  <sdc-svg-icon
    className="ml-2 w-4 h-4 shrink-0"
    [iconFolder]="'assets/img'"
    [name]="'clock-icon'"
    aria-hidden="true" />
</h5>
